/*    
<summary>
   This is a common component that shows SVG image of no data.
   Developer:Aashish Singh, Created Date:08-July-2025
</summary>
*/
import React from "react";

const AbortIconSVG: React.FC = () => {
  return (
    <svg
      id="Icons"
      height="20"
      viewBox="0 0 60 60"
      width="20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m10.4 51h39.2a4.284 4.284 0 0 0 3.73-2.272 5.016 5.016 0 0 0 -.069-5.117l-19.6-32.458a4.189 4.189 0 0 0 -7.322 0l-19.604 32.458a5.016 5.016 0 0 0 -.069 5.117 4.284 4.284 0 0 0 3.734 2.272zm19.6-2a4 4 0 1 1 4-4 4 4 0 0 1 -4 4zm0-34a5.006 5.006 0 0 1 5 5 88.674 88.674 0 0 1 -1.186 10c-1.424 8.3-2.714 9-3.814 9s-2.39-.7-3.814-9a88.674 88.674 0 0 1 -1.186-10 5.006 5.006 0 0 1 5-5z" />
      <circle cx="30" cy="45" r="2" />
      <path d="m10.4 56h39.2c7.381 0 11.871-8.467 7.941-14.974l-19.6-32.458a9.186 9.186 0 0 0 -15.882 0l-19.603 32.458c-3.93 6.507.56 14.974 7.944 14.974zm-5.377-13.423 19.6-32.458a6.187 6.187 0 0 1 10.746 0l19.6 32.458a6.992 6.992 0 0 1 .1 7.133 6.243 6.243 0 0 1 -5.469 3.29h-39.2a6.243 6.243 0 0 1 -5.472-3.29 6.992 6.992 0 0 1 .095-7.133z" />
      <path d="m33 20a3 3 0 0 0 -6 0c0 2.673 1.583 14.485 3 16.768 1.417-2.283 3-14.095 3-16.768z" />
    </svg>
  );
};

export default AbortIconSVG;
